// Class: starling.utils.Execute

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $import = require("./../../import_stub").default;
function Reflect() {return require("./../../Reflect");}

// Constructor

var Execute = function(){}

// Meta

Execute.__name__ = ["starling","utils","Execute"];
Execute.prototype = {
	
};
Execute.prototype.__class__ = Execute.prototype.constructor = $hxClasses["starling.utils.Execute"] = Execute;

// Init



// Statics

Execute.execute = function(func,args) {
	if(func != null) {
		if(args == null) {
			args = [];
		}
		var maxNumArgs = -1;
		var _g1 = args.length;
		var _g = maxNumArgs;
		while(_g1 < _g) {
			var i = _g1++;
			args[i] = null;
		}
		switch(maxNumArgs) {
		case -1:
			(Reflect().default).callMethod(func,func,args);
			break;
		case 0:
			func();
			break;
		case 1:
			func(args[0]);
			break;
		case 2:
			func(args[0],args[1]);
			break;
		case 3:
			func(args[0],args[1],args[2]);
			break;
		case 4:
			func(args[0],args[1],args[2],args[3]);
			break;
		case 5:
			func(args[0],args[1],args[2],args[3],args[4]);
			break;
		case 6:
			func(args[0],args[1],args[2],args[3],args[4],args[5]);
			break;
		case 7:
			func(args[0],args[1],args[2],args[3],args[4],args[5],args[6]);
			break;
		default:
			(Reflect().default).callMethod(func,func,args.slice(0,maxNumArgs));
		}
	}
}


// Export

exports.default = Execute;


//////////////////
// WEBPACK FOOTER
// ./lib/_gen/starling/utils/Execute.js
// module id = 45
// module chunks = 0